import React, { FC, useState } from "react";
import { Button, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatNum, getRandomStr } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { useShipmentDetailModel, initBoxInfo } from "../shipmentDetailModel";
import { IShipmentBoxInfo, IShipmentDetailsAdded, IShipmentTabEnum } from "@/views/shipment/shimentTypes";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";


//集装箱添加
export const TableBoxAdded: FC<RouterParamType> = ({ id, mode }) => {
    const { editBoxList, setEditBoxList, setTabActive,editFormVal } = useShipmentDetailModel(({ editBoxList, isSave }) => [editBoxList, isSave]);

    const columns = [
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '集装箱号',
            width: 160,
            dataIndex: 'containerCode',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '铅封号',
            width: 160,
            dataIndex: 'sealNum',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '司机',
            width: 160,
            dataIndex: 'driver',
            //editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '联系电话',
            width: 160,
            dataIndex: 'phone',
           // editable: true,
           editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '车牌号',
            width: 160,
            dataIndex: 'licensePlate',
            //editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '日期',
            width: 160,
            dataIndex: 'date',
           // editable: true,
           editable:editFormVal.status !== 'shipment.bl',
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
        {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any) =>
                <YhAuth resCode={ResourceAuthEnum.SH_ED_BOXDEL}>
                    <YhBut
                        type="delete"
                        txt="删除"
                        disabled={editBoxList.length <= 1}
                        click={() => {
                            //删除对应配件
                            setEditBoxList(origin => origin.filter(item => item.key !== record.key))
                        }}
                    />
                </YhAuth>
        }
    ];

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IShipmentDetailsAdded, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IShipmentDetailsAdded) => {
        let dataSource = [...editBoxList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setEditBoxList(dataSource);
    }

    const rightChildren = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={() => { setTabActive(IShipmentTabEnum.FILES) }}
    >上传附件</Button>

    const action =
        <YhAuth resCode={ResourceAuthEnum.SH_ED_CONTAINER}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    setEditBoxList(origin => [...origin, {
                        ...initBoxInfo,
                        key: getRandomStr()
                    }])
                }}
            >集装箱添加</Button>
        </YhAuth>

    return (
        <YhBox title={action} style={{ marginBottom: "10px", width: "100%" }} rightChildren={rightChildren}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumns as ColumnsType<IShipmentBoxInfo>}
                dataSource={editBoxList}
                pagination={false}
                scroll={{ x: 'max-content', }}
            />
        </YhBox>
    )
}